import { Component, OnInit, Input } from '@angular/core';
import { BcAccountClientService } from '../service/bc-account-client.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import { DialogService } from "ng2-bootstrap-modal";
import { AttTitleModalComponent } from "./att-title-modal/att-title-modal.component";
import { BcAllowanceModalComponent } from './bc-allowance-modal/bc-allowance-modal.component';
import { BcExtensionModalComponent } from "./bc-extension-modal/bc-extension-modal.component";

@Component({
	selector: 'app-bc-billing-list',
	templateUrl: './bc-billing-list.component.html',
	styleUrls: ['./bc-billing-list.component.scss']
})
export class BcBillingListComponent implements OnInit {

	@Input('client') client = [];

	// LocalStorage
	private permissoes;

	public clientList: any[] = [];
	public integralList: any[] = [];
	public showBillingList: boolean = true;

	constructor(private bcAccountClientService: BcAccountClientService, private router: Router, private flashMessagesService: FlashMessagesService, private dialogService: DialogService) { }

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.getIntegrantes(this.client['ID']);
	}

	sendToExtension() {
		let disposable = this.dialogService.addDialog(BcExtensionModalComponent, {
			selectedBillings: this.bcAccountClientService.selectedBillings,
			title: "Enviar títulos para Prorrogação",
			clientID: this.client['ID']
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((isConfirmed) => {

				if (isConfirmed) {
					this.router.navigateByUrl('/').then(
						() => {
							this.router.navigate(['/conta-cliente/detalhe', this.client['ID'], 'proposta-prorrogacao']);
						});
				}
			});
	}

	getIntegrantes(clientID) {
		this.bcAccountClientService.getIntegrantes(clientID).subscribe(result => {
			if (result.Success) {
				this.integralList = result.Result.filter(item => item.ContaClienteId !== this.client['ID']);
				this.clientList = result.Result.filter(item => item.ContaClienteId === this.client['ID']);

				if (this.integralList.length == 0 && this.clientList.length == 0)
					this.getTitulosNoPaginate(this.client['ID']);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getTitulosNoPaginate(clientID) {
		this.bcAccountClientService.getTitulosNoPaginate(clientID).subscribe(result => {
			if (result.Success) {
				this.clientList.push({
					ContaClienteId: this.client['ID'],
					Documento: this.client['Documento'],
					CodigoPrincipal: this.client['CodigoPrincipal'],
					Nome: this.client['Nome'],
					Apelido: this.client['Apelido'],
					TipoClienteId: this.client['TipoClienteID'],
					SegmentoId: this.client['SegmentoID'],
					QtdVencido: result.Result.QtdVencido,
					QtdAVencer: result.Result.QtdAVencer,
					TitulosVencidos: result.Result.TotalVencido,
					TitulosAVencer: result.Result.TotalAVencer,
				});
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	enableActions() {
		return this.bcAccountClientService.selectedBillings.length < 1;
	}

	getSelectedTitleTotal() {
		let sum = 0;

		for (let i = 0; i < this.bcAccountClientService.selectedBillings.length; i++) {
			sum += this.bcAccountClientService.selectedBillings[i].ValorInterno;
		}

		return sum;
	}

	clearSelectedBillings() {
		$(".biling-list tbody tr").each(function () {
			$("td:first-child input[type='checkbox']", this).prop("checked", false);
		});
		$(".select-all").prop("checked", false);
		this.bcAccountClientService.selectedBillings = [];
	}

	attBilling(item) {
		let disposable = this.dialogService.addDialog(AttTitleModalComponent, {
			selectedBillings: this.bcAccountClientService.selectedBillings,
			title: "Atualização de títulos"
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((isConfirmed) => {

				if (isConfirmed) {
					this.clearSelectedBillings();
					this.bcAccountClientService.billingChaged.next();
				}
			});
	}

	// Modal Abono
	openAllowanceModal() {
		let disposable = this.dialogService.addDialog(BcAllowanceModalComponent, {
			contaClienteID: this.client['ID'],
			selectedBillings: this.bcAccountClientService.selectedBillings,
			title: "Abono de Títulos"
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((isConfirmed) => {
				if (isConfirmed) {
					this.flashMessagesService.show("Titulo(s) enviados para abono!", { cssClass: 'alert-success', timeout: 6000 });
					this.router.navigateByUrl('/').then(
						() => {
							this.router.navigate(['/conta-cliente/detalhe', this.client['ID'], 'proposta-abono']);
						});
				}
			});
	}

	incluirPefin() {

		var list = [];

		this.bcAccountClientService.selectedBillings.forEach(b => {

			list.push({

				NumeroDocumento: b.NumeroDocumento,
				AnoExercicio: b.AnoExercicio,
				Linha: b.Linha,
				Empresa: b.Empresa,
				IncluiuPefin: true,

			});

		});

		this.bcAccountClientService.billingDocumentsSimpleAction(list).subscribe(result => {
			if (result.Success) {

				this.bcAccountClientService.selectedBillings.forEach(b => {
					b.DataPefinInclusao = new Date();
				});

				this.clearSelectedBillings();

				this.flashMessagesService.show("Data de Inclusão de Pefin registrada com sucesso!", { cssClass: 'alert-success', timeout: 6000 });

			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});


	}

	excluirPefin() {

		var list = [];

		this.bcAccountClientService.selectedBillings.forEach(b => {

			list.push({

				NumeroDocumento: b.NumeroDocumento,
				AnoExercicio: b.AnoExercicio,
				Linha: b.Linha,
				Empresa: b.Empresa,
				ExcluiuPefin: true,

			});

		});

		this.bcAccountClientService.billingDocumentsSimpleAction(list).subscribe(result => {
			if (result.Success) {

				this.bcAccountClientService.selectedBillings.forEach(b => {
					b.DataPefinExclusao = new Date();
				});

				this.flashMessagesService.show("Data de Exclusão de Pefin registrada com sucesso!", { cssClass: 'alert-success', timeout: 6000 });

				this.clearSelectedBillings();

			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});

	}

	incluirProtesto() {

		var list = [];

		this.bcAccountClientService.selectedBillings.forEach(b => {

			list.push({

				NumeroDocumento: b.NumeroDocumento,
				AnoExercicio: b.AnoExercicio,
				Linha: b.Linha,
				Empresa: b.Empresa,
				IncluiuProtesto: true,

			});

		});

		this.bcAccountClientService.billingDocumentsSimpleAction(list).subscribe(result => {
			if (result.Success) {

				this.bcAccountClientService.selectedBillings.forEach(b => {
					b.DataProtesto = new Date();
				});

				this.clearSelectedBillings();
				this.flashMessagesService.show("Data de Protesto registrada com sucesso!", { cssClass: 'alert-success', timeout: 6000 });

			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});

	}

	realizarProtesto() {

		var list = [];

		this.bcAccountClientService.selectedBillings.forEach(b => {

			list.push({

				NumeroDocumento: b.NumeroDocumento,
				AnoExercicio: b.AnoExercicio,
				Linha: b.Linha,
				Empresa: b.Empresa,
				RealizouProtesto: true,

			});

		});

		this.bcAccountClientService.billingDocumentsSimpleAction(list).subscribe(result => {
			if (result.Success) {

				this.bcAccountClientService.selectedBillings.forEach(b => {
					b.DataProtestoRealizado = new Date();
				});

				this.clearSelectedBillings();

				this.flashMessagesService.show("Data de Realização de Protesto registrada com sucesso!", { cssClass: 'alert-success', timeout: 6000 });

			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});

	}

	emitirDuplicata() {

		var list = [];

		this.bcAccountClientService.selectedBillings.forEach(b => {

			list.push({

				NumeroDocumento: b.NumeroDocumento,
				AnoExercicio: b.AnoExercicio,
				Linha: b.Linha,
				Empresa: b.Empresa,
				EmitiuDuplicata: true,

			});

		});

		this.bcAccountClientService.billingDocumentsSimpleAction(list).subscribe(result => {
			if (result.Success) {

				this.bcAccountClientService.selectedBillings.forEach(b => {

					if (b.DataDuplicata != null) {
						b.DataTriplicata = new Date();
					} else {
						b.DataDuplicata = new Date();
					}


				});

				this.clearSelectedBillings();

				this.flashMessagesService.show("Data de Emissão de Duplicata registrada com sucesso!", { cssClass: 'alert-success', timeout: 6000 });

			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});

	}

	hasStatus() {
		return this.bcAccountClientService.hasStatus;
	}



}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-billing-list/bc-billing-list.component.ts